import { Reveal, SectionHead } from "./Reveal";
import { IMAGES, CONTENT } from "../data/site";

const CHAPTERS = [
  { num: "02", title: "Our Mission", text: CONTENT.mission },
  { num: "03", title: "Our Vision", text: CONTENT.vision },
];

export const About = () => (
  <section id="about" data-testid="about-section" className="relative bg-[#0A0A0A] px-6 py-24 md:px-12 md:py-32">
    <div className="mx-auto max-w-7xl">
      <SectionHead
        id="about"
        overline="Chapter 01 — Who We Are"
        title="About Renuka Roofing Structurals"
      />

      <div className="mt-16 grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-8">
        <Reveal className="md:col-span-7">
          <div className="space-y-6 text-base md:text-lg leading-relaxed text-[#A3A3A3]">
            <p>{CONTENT.aboutP1}</p>
            <p>{CONTENT.aboutP2}</p>
            <p>{CONTENT.aboutP3}</p>
          </div>
        </Reveal>

        <Reveal delay={0.15} className="md:col-span-5">
          <div className="group relative overflow-hidden border border-white/10">
            <img
              src={IMAGES.about}
              alt="Fabrication workshop at Renuka Roofing Structurals"
              className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <span className="absolute bottom-4 left-4 text-[10px] uppercase tracking-[0.3em] text-white/70">
              Fabrication Workshop · Hyderabad
            </span>
          </div>
        </Reveal>
      </div>

      <div className="mt-20 grid grid-cols-1 gap-px border border-white/10 bg-white/10 md:grid-cols-2">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.12} className="bg-[#0A0A0A]">
            <div data-testid={`about-chapter-${c.num}`} className="h-full p-10 md:p-12">
              <span className="font-display text-5xl font-extrabold text-outline">{c.num}</span>
              <h3 className="mt-6 font-display text-2xl font-bold tracking-tight">{c.title}</h3>
              <p className="mt-4 text-base leading-relaxed text-[#A3A3A3]">{c.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
